/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliverFeeKrGradeAmountRespVo
 */
export interface GetDeliverFeeKrGradeAmountRespVo {
    /**
     * 用户等级id
     * @type {number}
     * @memberof GetDeliverFeeKrGradeAmountRespVo
     */
    userGradeId?: number;
    /**
     * 用户等级名称
     * @type {string}
     * @memberof GetDeliverFeeKrGradeAmountRespVo
     */
    userGradeName?: string;
    /**
     * 金额
     * @type {number}
     * @memberof GetDeliverFeeKrGradeAmountRespVo
     */
    amount?: number;
}

/**
 * Check if a given object implements the GetDeliverFeeKrGradeAmountRespVo interface.
 */
export function instanceOfGetDeliverFeeKrGradeAmountRespVo(value: object): value is GetDeliverFeeKrGradeAmountRespVo {
    return true;
}

export function GetDeliverFeeKrGradeAmountRespVoFromJSON(json: any): GetDeliverFeeKrGradeAmountRespVo {
    return GetDeliverFeeKrGradeAmountRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeKrGradeAmountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeKrGradeAmountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userGradeId': json['userGradeId'] == null ? undefined : json['userGradeId'],
        'userGradeName': json['userGradeName'] == null ? undefined : json['userGradeName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function GetDeliverFeeKrGradeAmountRespVoToJSON(json: any): GetDeliverFeeKrGradeAmountRespVo {
    return GetDeliverFeeKrGradeAmountRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeKrGradeAmountRespVoToJSONTyped(value?: GetDeliverFeeKrGradeAmountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userGradeId': value['userGradeId'],
        'userGradeName': value['userGradeName'],
        'amount': value['amount'],
    };
}

